import script from "./MessageItemTalkroom.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageItemTalkroom.vue?vue&type=script&lang=ts&setup=true"

import "./MessageItemTalkroom.vue?vue&type=style&index=0&id=560cc4de&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560cc4de"]])

export default __exports__